/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_EditInputs */

const vi_tea_lot_edit = /** @type {(inputs: Tea_Lot_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa lô chè`)
};

/**

* @param {Tea_Lot_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_edit = /** @type {((inputs?: Tea_Lot_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_edit(inputs)
});